/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Semantic_UnavailableInputs */

const en_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic search is unavailable right now. Showing keyword matches instead.`)
};

const zh_hans1_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语义搜索暂时不可用，改为显示关键词匹配结果。`)
};

const pt_br2_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pesquisa semântica está indisponível no momento. Mostrando resultados por palavra-chave.`)
};

const es_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La búsqueda semántica no está disponible en este momento. Mostrando coincidencias por palabra clave.`)
};

const fr_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La recherche sémantique est indisponible pour le moment. Affichage des correspondances par mot-clé à la place.`)
};

const de_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die semantische Suche ist gerade nicht verfügbar. Stattdessen werden Keyword-Treffer angezeigt.`)
};

const ru_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семантический поиск сейчас недоступен. Показаны совпадения по ключевым словам.`)
};

const it_search_semantic_unavailable = /** @type {(inputs: Search_Semantic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ricerca semantica non è disponibile al momento. Vengono mostrati i risultati per parola chiave.`)
};

/**
* | output |
* | --- |
* | "Semantic search is unavailable right now. Showing keyword matches instead." |
*
* @param {Search_Semantic_UnavailableInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_semantic_unavailable = /** @type {((inputs?: Search_Semantic_UnavailableInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Semantic_UnavailableInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_semantic_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_search_semantic_unavailable(inputs)
	if (locale === "es") return es_search_semantic_unavailable(inputs)
	if (locale === "fr") return fr_search_semantic_unavailable(inputs)
	if (locale === "de") return de_search_semantic_unavailable(inputs)
	if (locale === "ru") return ru_search_semantic_unavailable(inputs)
	if (locale === "it") return it_search_semantic_unavailable(inputs)
	return en_search_semantic_unavailable(inputs)
});